export default {
  P1: "#06257B",
  P2: "#e6f7f9",
  S1: "#A3CAE7",
  S2: "#FEF4E8",
  BG1: "#ffffff",
  BG2: "#f5f6fa",
  BG3: "#AAB2BD",
  G1: "#212121",
  G2: "#757575",
  G3: "#9e9e9e",
  G4: "#e0e0e0",
  G5: "#4D4D4D",
  gradientStart: "#06257B",
  gradientEnd: "#021457",
};
